import React from 'react';
import { Sheet } from '../../../../../../mobile/structural/sheet';
import { UseSheetReturnType } from '../../../../../../mobile/structural/sheet/hooks/useSheet';
import InsertMenuToolbarContent from './InsertMenuToolbarContent';

const INSERT_MENU_SHEET_DEFAULT_SNAP_POINT = '0.5max';

export type MobileInsertMenuSheetProps = {
    sheetProps: UseSheetReturnType;
    isTaskListContext: boolean;
};

const MobileInsertMenuSheet = ({ sheetProps, isTaskListContext }: MobileInsertMenuSheetProps) => {
    const { closeSheet } = sheetProps;

    return (
        <Sheet
            className="mobile-insert-menu-tool"
            {...sheetProps}
            defaultSnapPoint={INSERT_MENU_SHEET_DEFAULT_SNAP_POINT}
        >
            <Sheet.Overlay />
            <Sheet.Panel>
                <Sheet.Content>
                    <InsertMenuToolbarContent closePopup={closeSheet} size="lg" isTaskListContext={isTaskListContext} />
                </Sheet.Content>
            </Sheet.Panel>
        </Sheet>
    );
};

export default MobileInsertMenuSheet;
